"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.typography = void 0;
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/**
 * Typographic choices that belong to the tools rather than to any product's
 * brand, so no product's theme supplies them. StyleX resolves only variables
 * across files, which is why these are `defineVars` rather than exported
 * strings.
 */
const typography = exports.typography = {
  monospace: "var(--x1uy40nn)",
  __themeName__: "x1noaob4"
};